const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  feature: "all",
  search: "",
};

const filterSlice = createSlice({
  name: "bookList",
  initialState,
  reducers: {
    featureSelected: (state, action) => {
      state.feature = action.payload;
    },
    searched: (state, action) => {
      state.search = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { featureSelected, searched } = filterSlice.actions;
